module.exports = __webpack_public_path__ + "img/icon2.195d0baa.png";